export default __webpack_public_path__ + "static/media/adveris.9dd38eb1.mp4";